/**
 * Created by Ning Jiang on 6/5/2019.
 */

import {BetLineEvent} from "@nolimitcity/slot-game/bin/core/betline/event/BetLineEvent";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {GameConfig} from "@nolimitcity/slot-game/bin/core/gameconfig/GameConfig";
import {GameModeEvent} from "@nolimitcity/slot-game/bin/core/gamemode/event/GameModeEvent";
import {
    IPickAndClickConfig,
    PickAndClickController
} from "@nolimitcity/slot-game/bin/core/pickandclick/PickAndClickController";
import {Reels} from "@nolimitcity/slot-game/bin/core/reel/reelarea/Reels";
import {ScreenEvent} from "@nolimitcity/slot-game/bin/core/screen/event/ScreenEvent";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {WinPresentationEvent} from "@nolimitcity/slot-game/bin/core/winpresentation/event/WinPresentationEvent";
import {Logger} from "@nolimitcity/slot-launcher/bin/utils/Logger";
import {PPFreespinAmbientParticles} from "../../background/PPFreespinAmbientParticles";
import {PPGameMode} from "../../gamemode/PPGameMode";
import {PixiesVsPiratesGameConfig} from "../../PixiesVsPiratesGameConfig";
import {PixiesVsPiratesGameModuleConfig} from "../../PixiesVsPiratesGameModuleConfig";
import {PixiesVsPiratesSoundConfig} from "../../PixiesVsPiratesSoundConfig";
import {PPReelController} from "../../reel/PPReelController";
import {BattleEvent} from "../../reelstoppresentation/battlecollect/BattleEvent";
import {IPixiesVsPiratesParsedServerData} from "../../server/parseddata/IPixiesVsPiratesParsedServerData";
import {PixiesVsPiratesParsedInitData} from "../../server/parseddata/PixiesVsPiratesParsedInitData";
import {PPPickNClickIntroView} from "./PPPickNClickIntroView";

export class PPPickNClickIntroController extends PickAndClickController {

    private _gameView:PPPickNClickIntroView;
    private _isRestoreRespin:boolean;
    private _fsAmbientParticles:PPFreespinAmbientParticles;

    constructor(config:IPickAndClickConfig) {
        super("PickNClick", config);
        this._fsAmbientParticles = new PPFreespinAmbientParticles(StageManager.getLayer(PixiesVsPiratesGameConfig.instance.LAYERS.FREESPIN_PARTICLES.name));
        this._gameView = <PPPickNClickIntroView>this._view;
        this._gameView.getPlaySoundCallback(() => SlotGame.sound.playEffect(PixiesVsPiratesSoundConfig.FSSELECT_SHOWING));
        this._gameView.getFeatureStartSoundCallback(() => SlotGame.sound.playEffect(PixiesVsPiratesSoundConfig.FS_INTRO));
    }

    protected addFeatureEventHandlers():void {
        EventHandler.addEventListener(this, ScreenEvent.GAME_START, (event:GameEvent) => this.onGameStart());
        EventHandler.addEventListener(this, BattleEvent.XWAYS_UPDATED, (event:GameEvent) => this.dispatchCompleteEvent());
    }

    private onGameStart():void {
        if(this._isRestoreRespin) {
            PixiesVsPiratesGameModuleConfig.soundPlayer.switchToFreespinMusic();
        }
    }

    protected calculateIsTriggered(data:IPixiesVsPiratesParsedServerData):boolean {
        return data.nextMode === PPGameMode.FREESPIN_PICK;
    }

    protected calculateIsRestoreTriggered(data:PixiesVsPiratesParsedInitData):boolean {
        this._isRestoreRespin = data.isRestoreState && data.nextMode === PPGameMode.FREESPIN;
        return data.mode === PPGameMode.FREESPIN_PICK;
    }

    protected parseButtonConfigs(data:IPixiesVsPiratesParsedServerData):any[] {
        return [1, 2]; // pick index: 1-Queen, 2-Captain.
    }

    protected onButtonClick(selectedIndex:number, autoClicked:boolean = false):void {
        // StarStruckGameModuleConfig.soundPlayer.playEffect(StarStruckSoundConfig.instance.BONUS_STAR_PICK);

        // when autoClicked, send 3 and 4 instead of 1 and 2.
        autoClicked ? selectedIndex += 2 : selectedIndex;
        super.onButtonClick(selectedIndex, autoClicked);
        SlotGame.sound.playEffect(PixiesVsPiratesSoundConfig.FS_SELECT);
        PixiesVsPiratesGameModuleConfig.soundPlayer.switchToFreespinMusic();
    }

    protected playReplay():void {
        // autoSelected
        if(this._replayPlayerSelectionIndex > 2) {
            this._view.clickButton(this._replayPlayerSelectionIndex - 2 - 1, true);
        } else {
            this._view.clickButton(this._replayPlayerSelectionIndex - 1);
        }
    }

    protected close():void {
        SlotGame.keypad.setZeroBetSpinCounter(this._serverData!.freespinsLeft!);
        EventHandler.dispatchEvent(new GameEvent(WinPresentationEvent.UPDATE_WIN_PRESENTATION_BET_WINS, [])); // clear wins for individual win and idle animations.
        EventHandler.dispatchEvent(new GameEvent(BattleEvent.SET_PLAYER_SELECTION, (<IPixiesVsPiratesParsedServerData>this._serverData!).playerFSSelection));
        EventHandler.dispatchEvent(new GameEvent(GameModeEvent.CHANGE_MODE, {newMode : this._serverData!.nextMode}));
        if((<IPixiesVsPiratesParsedServerData>this._serverData!).freespinRound === 1) {
            for(let i:number = 0; i < 6; i++) {
                const reelSize:number = (i === 0 || i === 5) ? 3 : 6;
                (<number[]>GameConfig.instance.STACKED_SYMBOLS!["W"].totalNum)[i] = reelSize;
                const reel:PPReelController = <PPReelController>Reels.getReel(i);
                reel.resetReelSymbols(reelSize, this._serverData!.reels[i]);
            }
        }

        super.close();
    }

    //To Do: Look for better way of delay spin
    protected onCloseComplete():void {
        Logger.logDev(`Close PickAndClick ${this.moduleName}`);
        this._fsAmbientParticles.stopAnimation();
        this.reset();
        this.showKeypad();
        SlotGame.winFieldController.showWinField();
        EventHandler.dispatchEvent(new GameEvent(BetLineEvent.SET_ENABLED, true));
        EventHandler.dispatchEvent(new GameEvent(BattleEvent.UPDATE_XWAYS));

        // This will turn off Autoplay if in restricted jurisdiction
        if(SlotGame.autoPlay.turnOffAutoplayOnBonus) {
            SlotGame.autoPlay.turnOffAutoplayOnBonus();
        }
    }

    protected dispatchCompleteEvent():void {
        EventHandler.dispatchEvent(new GameEvent(ScreenEvent.PICK_AND_CLICK_CLOSED, this._showWinPresentations));
    }

    // when restoreSelected, show the selection and the animation after.
    protected show(isRestoreSelected:boolean):void {
        this._fsAmbientParticles.startAnimation();
        this._view.show(this._buttonConfigs!, this._serverData!, isRestoreSelected ? () => this.finish() : () => this.onShowComplete());
        this.hideKeypad();
        EventHandler.dispatchEvent(new GameEvent(BetLineEvent.SET_ENABLED, false));
        EventHandler.dispatchEvent(new GameEvent(BetLineEvent.HIDE_ALL_BET_LINES));

        // When restore in freespin, don't show the intro but we need the intro to init the freespin scene.
        if(this.doTransitions) {
            this.doTransitions();
        }
    }
}